<template>
  <v-flex>
    <v-dialog
      v-if="this.modelReparacion"
      v-model="dialogFormularioReparacion"
      :max-width="600"
      persistent
    >
      <reparacion-formulario
        @cerrarFormularioReparacion="dialogFormularioReparacion = false"
        :modelReparacion="this.modelReparacion"
        :accion="this.accion"
      />
    </v-dialog>

    <v-dialog v-model="showConfirmacionEliminacion" width="500" persistent>
      <v-card :color="'rgb(250,250,250)'">
        <v-toolbar dense :color="colorBarraFormulario" :dark="dark" flat>
          <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
            <h5 v-bind:style="{ color: 'white' }">
              Confirmación de eliminación
            </h5>
          </v-toolbar-title>
          <v-spacer></v-spacer>

          <v-icon
            size="30"
            :color="'white'"
            @click="showConfirmacionEliminacion = false"
            >mdi-close-circle</v-icon
          >
        </v-toolbar>
        <v-card-text class="mt-0">
          <v-row class="mt-8 mb-1" justify="center">
            <v-label :dark="dark">
              ¿Está seguro que desea eliminar la reparación?
            </v-label>
          </v-row>

          <v-row class="mt-6 mb-2" justify="center">
            <v-chip
              class="mr-4"
              label
              color="blue-grey darken-3"
              @click="_eliminarReparacion()"
            >
              <v-container>
                <span v-bind:style="{ color: 'white' }">Eliminar</span>
              </v-container>
            </v-chip>
            <v-chip
              label
              class="ml-4"
              color="blue-grey darken-3"
              @click="showConfirmacionEliminacion = false"
            >
              <v-container width="120">
                <span v-bind:style="{ color: 'white' }">Cancelar </span>
              </v-container>
            </v-chip>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card class="mt-2" color="rgb(250, 250, 250)">
      <v-toolbar :dark="!dark" dense color="blue-grey darken-2" flat>
        <v-toolbar-title :dark="!dark">REPARACIONES</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <!-- <v-chip class="mr-4" :color="colorAccent2" link @click="_imprimir">
          <v-avatar left>
            <v-icon size="20" color="white">mdi-printer</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">IMPRIMIR</h5>
        </v-chip> -->
        <v-chip
          class="mr-1"
          link
          :color="colorEBikeAccent1"
          @click="_crearReparacion"
        >
          <v-avatar left>
            <v-icon size="20" color="white">mdi-account-plus</v-icon>
          </v-avatar>
          <h5 v-bind:style="{ color: 'white' }">NUEVA REPARACION</h5>
        </v-chip>
      </v-toolbar>
    </v-card>

    <v-row v-if="loading">
      <v-spacer />
      <v-row class="mt-12">
        <v-col class="mt-12">
          <v-progress-linear
            class="mt-12 mb-12"
            :color="colorEBikeAccent1"
            indeterminate
            width="200px"
            rounded
            height="6"
          ></v-progress-linear>
        </v-col>
      </v-row>
      <v-spacer />
    </v-row>

    <v-card v-else class="mt-2 mb-2" color="rgb(250, 250, 250, 1)">
      <v-card-text>
        <v-row v-if="reparaciones" class="mt-0" justify="start" dense>
          <v-col cols="12">
            <v-data-table
              locale="es"
              v-if="reparaciones"
              dense
              light
              :headers="headersLargo"
              :items="reparaciones"
              :items-per-page="reparaciones.length"
              hide-default-footer
              class="elevation-1"
            >
              <template v-slot:[`item.fecha_inicial`]="{ item }">
                <span>
                  {{ _captionFecha(item.fecha_inicial, true) }}
                </span>
              </template>

              <template v-slot:[`item.fecha_final`]="{ item }">
                <span>
                  {{ _captionFecha(item.fecha_final, true) }}
                </span>
              </template>

              <template v-slot:[`item.bici`]="{ item }">
                <v-chip
                  class="px-2"
                  :color="'red'"
                  style="width: 40px"
                  label
                  small
                >
                  <span v-bind:style="{ color: 'white' }">
                    {{ (item.bici && item.bici.talla ? item.bici.talla : '') + (item.bici && item.bici.numero ? item.bici.numero : '') }}
                  </span>
                </v-chip>
              </template>

              <template v-slot:[`item.action`]="{ item }">
                <v-chip
                  class="mr-1"
                  label
                  small
                  :color="colorAccent2"
                  text-color="white"
                  link
                  @click="_editar(item)"
                >
                  Editar
                </v-chip>

                <v-chip
                  label
                  small
                  color="red lighten-2"
                  text-color="white"
                  link
                  @click="_delete(item)"
                >
                  Eliminar
                </v-chip>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ReparacionFormulario from "../components/formularios/ReparacionFormulario";

export default {
  components: {
    ReparacionFormulario,
  },

  data: () => ({
    mostrarbusqueda: true,
    accion: "",

    dialogFormularioReparacion: false,
    modelReparacion: null,
    showConfirmacionEliminacion: false,

    headersLargo: [
      // { text: "ID", width: "80px", align: "left", sortable: false, value: "id" },
      {
        text: "INICIO",
        align: "left",
        sortable: false,
        width: 180,
        value: "fecha_inicial",
      },
      {
        text: "FINAL",
        align: "left",
        sortable: false,
        width: 180,
        value: "fecha_final",
      },
      {
        text: "BICI",
        align: "left",
        sortable: false,
        width: 100,
        value: "bici",
      },
      {
        text: "OBSERVACIONES",
        align: "left",
        sortable: false,
        value: "observaciones",
      },
      {
        text: "ACCIONES",
        width: "170px",
        value: "action",
        sortable: false,
        align: "center",
      },
    ],
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorEBikeAccent1",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),

    ...mapState("reparaciones", ["reparaciones", "reparacionSelec"]),
  },

  watch: {},

  mounted() {
    this._getReparaciones(true);
  },

  methods: {
    ...mapActions("reparaciones", [
      "getReparaciones",
      "eliminarReparacion",
      "updateReparacion",
    ]),
    ...mapMutations("reparaciones", ["setReparacionSelec"]),

    _inicializarModelReparacion() {
      this.modelReparacion = {
        id: null,
        fecha_inicial: null,
        fecha_final: null,
        bici: {
          id: null,
          talla: null,
          numero: null,
        },
        bici_id: null,
        observaciones: null,
      };
    },

    _captionFecha(fecha, con_diasemana) {
      if (fecha) {
        return (
          (con_diasemana ? this._diasemana(fecha) + " " : "") +
          fecha.substring(8, 10) +
          "-" +
          fecha.substring(5, 7) +
          "-" +
          fecha.substring(0, 4)
        );
      } else {
        return "";
      }
    },

    _diasemana(date) {
      let days = ["LUN", "MAR", "MIE", "JUE", "VIE", "SAB", "DOM"];
      let d = new Date(date.substring(0, 10));
      let dd = d.getUTCDay();
      if (dd > 0) {
        return days[d.getUTCDay() - 1];
      } else {
        return days[6];
      }
    },

    _imprimir() {},

    async _getReparaciones(showload) {
      const params = {};
      await this.getReparaciones([this.access_token, params, true]);
    },

    _delete(item) {
      this.setReparacionSelec(item);
      this.showConfirmacionEliminacion = true;
    },

    _crearReparacion() {
      this._inicializarModelReparacion();
      this.accion = "crear";
      this.dialogFormularioReparacion = true;
    },

    _editar(item) {
      this.setReparacionSelec(item);
      let temp = JSON.parse(JSON.stringify(this.reparacionSelec));
      this.modelReparacion = temp;
      this.accion = "editar";
      this.dialogFormularioReparacion = true;
    },

    async _eliminarReparacion() {
      this.showConfirmacionEliminacion = false;
      if (this.reparacionSelec != null) {
        await this.eliminarReparacion([
          this.access_token,
          this.reparacionSelec.id,
        ]);
      }
    },
  },
};
</script>
